import { createFileRoute } from '@tanstack/react-router';

import { EhrContractsPage } from '@apps/web/features/admin_ehr_contracts';

export const Route = createFileRoute(
    '/_app/admin/ehr-contracts/{-$vendor}/{-$endpoint}',
)({
    component: EhrContractsRoute,
    head: () => ({
        meta: [{ title: 'EHR Contracts | Phoebe Admin' }],
    }),
});

function EhrContractsRoute() {
    const { vendor, endpoint } = Route.useParams();
    return <EhrContractsPage vendorId={vendor} endpointId={endpoint} />;
}
